let wait = 200;
export default function logError(error, info) {
  if (window.Sentry) {
    log(error, info);
  } else {
    setTimeout(() => logError(error, info), wait);
    wait = wait * 2;
  }
}

function log(error, info) {
  window.Sentry.withScope(scope => {
    Object.keys(error).forEach(key => {
      scope.setExtra(key, info[key]);
    });
    window.Sentry.captureException(error);
  });
}
